import { Button } from '@components/ui/Button';

interface UnsavedChangesBarProps {
  onDiscard: () => void;
  onSave: () => void;
}

export const UnsavedChangesBar = ({ onDiscard, onSave }: UnsavedChangesBarProps) => {
  return (
    <div className="fixed bottom-10 left-1/2 z-50 flex -translate-x-1/2 items-center gap-4 rounded-full border border-[var(--base-border,#3d3d3d)] bg-[var(--base-surface-1,#141414)] px-5 py-3 shadow-[0_8px_30px_rgb(0,0,0,0.4)]">
      <span className="mr-2 hidden text-sm font-medium text-[var(--text-dark-secondary,rgba(255,255,255,0.7))] sm:inline-block">
        Unsaved changes
      </span>
      <Button
        variant="ghost"
        size="sm"
        className="h-8 rounded-full px-4 text-[13px] text-[var(--text-dark-secondary,rgba(255,255,255,0.7))] hover:bg-[var(--base-surface-2,#231f1f)] hover:text-white"
        onClick={onDiscard}
      >
        Discard
      </Button>
      <Button
        variant="primary"
        size="sm"
        className="h-8 rounded-full bg-[var(--state-brand-active,#36d399)] px-5 text-[13px] font-medium text-black hover:bg-[#2bb481]"
        onClick={onSave}
      >
        Save changes
      </Button>
    </div>
  );
};
